import { useMemo } from 'react';
import { Epoch } from '../types/epochs';

export const useYears = (epochs: Epoch[]) => {
  return useMemo(() => {
    const yearsArray: number[] = [];
    
    epochs.forEach(epoch => {
      epoch.events.forEach(event => {
        if (event.year.includes('-')) {
          const [start, end] = event.year.split('-');
          yearsArray.push(parseInt(start), parseInt(end));
        } else {
          yearsArray.push(parseInt(event.year));
        }
      });
    });

    const uniqueYears = yearsArray.filter((year, index) => yearsArray.indexOf(year) === index);
    return uniqueYears.sort((a, b) => a - b);
  }, [epochs]);
}; 